
export * from '../../frontend-js-web/__liferay__/index.js';
